/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, Typography} from "@mui/material";
import Puntos_Clave_Informacion from "./SubComponentes/Puntos_Clave_Informacion";
import {Splide, SplideSlide} from '@splidejs/react-splide';
import '@splidejs/react-splide/css/core';
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Puntos_Informacion = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid2
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            spacing={2}
            size={12}>

            <Grid2 container size={12}
                   sx={{maxWidth: '1400px', px: 3}}>

                <Grid2 container size={{xs: 12, sm: 12, md: 11}}>

                    <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                        <Typography sx={{fontSize: 20, lineHeight: 1.4}}>
                            {item && item.parrafoComplementario}
                        </Typography>
                    </Grid2>

                </Grid2>

                <Grid2 container
                       justifyContent={'center'}
                       alignItems={'center'}
                       size={{xs: 12, sm: 12, md: 12}}>
                    <Grid2 container size={{xs: 12, sm: 6, md: 8}} sx={{my: 10}}>
                        <Puntos_Clave_Informacion item={item}/>
                    </Grid2>

                    <Grid2 container size={{xs: 12, sm: 6, md: 4}}>

                    </Grid2>
                </Grid2>

                <Splide
                    aria-label="My Favorite Images"
                    options={{
                        arrows: false,
                        pagination: false,
                        autoplay: true,
                        interval: 5000,
                        width: '100%',
                        height: '100%',
                        perPage: sCell ? 1 : 3,
                        perMove: 1,
                        gap: '1rem',
                        breakpoints: {
                            600: {
                                perPage: 1,
                                gap: '1rem',
                            },
                        },
                    }}
                >

                    {item.imgs && item.imgs.map((it) => {
                        return (
                            <SplideSlide>
                                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                                    <img
                                        style={{borderRadius: 30}}
                                        src={it}
                                        width={'100%'}
                                        height={'100%'}
                                    />
                                </Grid2>
                            </SplideSlide>
                        )
                    })}


                </Splide>


            </Grid2>

        </Grid2>
    )

}
export default Puntos_Informacion;

